import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FieldKeyType, SavedQuerySearch } from '../../entities/saved-queries/saved-query-search.entity';
import { ISavedQuery, SavedQuery } from '../../entities/saved-queries/saved-query.entity';
import { MapObjectToHttpParams } from '../../helpers/map-obj-to-http-params.helper';
import { ApiList } from '../../record/entities/api-list.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { ApiListToPaginatedResults } from '../../record/helpers/api-list-to-paginated-results.helper';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class SavedQueriesService {
    private readonly ENDPOINT: string = 'filters';
    constructor(private readonly http: AbstractHttpService) {}

    public getSavedQueries(searchParams: SavedQuerySearch): Observable<PaginatedResults<SavedQuery>> {
        // Force fieldKeyType to dottedKey ("who still uses FlatKeys anyhow?")
        searchParams.fieldKeyType = FieldKeyType.DottedKey;
        return this.http
            .get<ApiList<SavedQuery>>(this.ENDPOINT, MapObjectToHttpParams(searchParams))
            .pipe(map(apiList => ApiListToPaginatedResults(apiList, searchParams.nrOfResults)));
    }

    public getTotalSavedQueries(): Observable<number> {
        return this.getSavedQueries({
            startIndex: 0,
            nrOfResults: 0
        }).pipe(map(paginatedResults => paginatedResults.paginationInfo.totalNumberOfResults));
    }

    public saveQuery(query: Partial<ISavedQuery>): Observable<SavedQuery> {
        return this.http.post<ISavedQuery>(this.ENDPOINT, query).pipe(map(resp => new SavedQuery(resp)));
    }

    /** `PUT .../filters/:id` replaces the whole filter and returns `204` — see the E-Depot API's "Updating a filter". */
    public updateQuery(id: string, query: Partial<ISavedQuery>): Observable<void> {
        return this.http.put<void>(`${this.ENDPOINT}/${id}`, query);
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.ENDPOINT}/${id}`);
    }
}
